
// /Components
// import React from "react";
import React, { useState } from "react";

import Slider from "react-slick";
import gsap from 'gsap'
import { ScrollTrigger } from 'gsap/all';
// import SplitType from 'split-type'

import AnimatedText from "../component/animation";
// import FadeInOnScroll from "../component/scrollanimation";
import PDFModal from "../component/PDFmodal";

import ContactForm from '../component/form-contact';
import Header from "../component/header";
import Footer from "../component/footer";
// Image
import about01 from '../assets/images/Home/whoweare/Introduction-1.webp'
import about02 from '../assets/images/Home/whoweare/Introduction-2.webp'
import about03 from '../assets/images/Home/whoweare/Introduction-3.webp'
import about04 from '../assets/images/Home/whoweare/Introduction-4.webp'



// Cater
import cater01 from '../assets/images/Homepage/industriescater/brewery-and-distillery-.webp'
import cater02 from '../assets/images/Homepage/industriescater/cosmetic-manufacturing.webp'
import cater03 from '../assets/images/Homepage/industriescater/pharmaceutical-and-cosmetic-.webp'
import cater04 from '../assets/images/Homepage/industriescater/food-and-beverage.webp'
import cater05 from '../assets/images/Homepage/industriescater/chemical-processing.webp'


// client Image 
// import ClientLogo from '../assets/Logo-client.jpg'                                                                                               
// import company_02 from '../assets/clients/company_02.webp'
// import company_03 from '../assets/clients/company_03.webp'
// import company_04 from '../assets/clients/company_04.webp'
// import company_05 from '../assets/clients/company_05.webp'

// import set01 from '../assets/images/Homepage/services/ewtu9uyqwzfb2vguwadp.webp'
// import set02 from '../assets/images/Homepage/services/oihgjysjb0c8i59ajcqy.webp'
// import set03 from '../assets/images/Homepage/services/vjke8icu9tkkyhgwfevl.webp'
// import set04 from '../assets/images/Homepage/services/wthqacbwcldrtwfnsepr.webp'

import  set01 from '../assets/images/Homepage/underwhoweare/Uncompromised-Quality-1.webp'
import  set02 from '../assets/images/Homepage/underwhoweare/Tailored-Engineering-2.webp'
import  set03 from '../assets/images/Homepage/underwhoweare/End-to-End.webp'
import  set04 from '../assets/images/Homepage/underwhoweare/Customer-Centric.webp'
import  set05 from '../assets/images/Homepage/underwhoweare/Tailored-Engineering-2.webp'



// Installation
import installation01 from '../assets/images/Homepage/Customer_Installations/1.webp'
import installation02 from '../assets/images/Homepage/Customer_Installations/2.webp'
import installation03 from '../assets/images/Homepage/Customer_Installations/3.webp'
import installation04 from '../assets/images/Homepage/Customer_Installations/4.webp'
import installation05 from '../assets/images/Homepage/Customer_Installations/5.webp'
import installation06 from '../assets/images/Homepage/Customer_Installations/Dunkel.webp'
import installation07 from '../assets/images/Homepage/Customer_Installations/Benki.webp'
import installation08 from '../assets/images/Homepage/Customer_Installations/8.webp'
import installation09 from '../assets/images/Homepage/Customer_Installations/9.webp'
import installation10 from '../assets/images/Homepage/Customer_Installations/10.webp'


// import installation_01 from '../assets/project-single.jpg'

import Service06 from '../assets/images/Homepage/ourproducts/Breweries.webp'
import Service03 from '../assets/images/Homepage/ourproducts/Chemical-Plants.webp'
import Service02 from '../assets/images/Homepage/ourproducts/Distilleries.webp'
import Service05 from '../assets/images/Homepage/ourproducts/Food-&-Beverage-Processing.webp'
import Service04 from '../assets/images/Homepage/ourproducts/Cosmetic-Industry.webp'
import Service01 from '../assets/images/Homepage/ourproducts/Pharmaceutical-&-Life-Sciences.webp'

// clients

import Clients01 from '../assets/images/Homepage/Clients/eto1a1towdeiyhkzpauu.webp'
import Clients02 from '../assets/images/Homepage/Clients/ilfd9xfyxn9hodos2fim.webp'
import Clients03 from '../assets/images/Homepage/Clients/pwin1teib48v8nq8eh5a.webp'
import Clients04 from '../assets/images/Homepage/Clients/q423aceowfavv36isy7i.webp'
import Clients05 from '../assets/images/Homepage/Clients/tpfhig2q5nbnsrnv82gj.webp'
import Clients06 from '../assets/images/Homepage/Clients/voyrwmdf124jnu07ayde.webp'
import Clients07 from '../assets/images/Homepage/Clients/yozpukmvapflnx7areoy.webp'
import Clients08 from '../assets/images/Homepage/Clients/zmxkunnvdpmzl1g8zrsm.webp'
import Clients09 from '../assets/images/Homepage/Clients/bonomi.webp'
import Clients10 from '../assets/images/Homepage/Clients/zmxkunnvdpmzl1g8zrsm.webp'
import Clients11 from '../assets/images/Homepage/Clients/Benki-Coffee.webp'
import Clients12 from '../assets/images/Homepage/Clients/Dads-Hack.webp'
import Clients13 from '../assets/images/Homepage/Clients/Chin-Lungs.webp'
import Clients14 from '../assets/images/Homepage/Clients/Water-Mass-.webp'

import icon01 from '../assets/images/Home/icons/Process-Equipment.webp'
import icon02 from '../assets/images/Home/icons/Piping.webp'
import icon03 from '../assets/images/Home/icons/CIP-SIP-Systems.webp'
import icon04 from '../assets/images/Home/icons/Pasteurization-Systems.webp'
import icon05 from '../assets/images/Home/icons/Heat-Exchange-&-Thermal-Management.webp'
import icon06 from '../assets/images/Home/icons/Fermentation-Process.webp'
import icon07 from '../assets/images/Home/icons/Utility-&-Industrial-Piping.webp'
// import icon08 from '../assets/images/Home/icons/Water-Degassing.webp'


// Team
import coreteam from '../assets/images/Home/Ourteam/Our-Core-Teams.webp'
import director   from '../assets/images/Home/Ourteam/Managing-Director-1.webp'
 
// Video 
import video from '../assets/videos/videos04.mp4'


// CSS styles
import '../assets/fonts/fontawesome/css/all.min.css';
import pdfFile from '../assets/images/ARKANE-CatalogueR6.pdf'

 gsap.registerPlugin(ScrollTrigger)  

function Home() {
  const [open, setOpen] = useState(false);

  const pdfUrl = pdfFile;


    var settings = {
        dots: false,
        infinite: true,
        slidesToShow: 1,
        slidesToScroll: 1,
        cssEase: 'linear',
        autoplay: true,
    //   autoplay: true,
    // speed: 500,
    // autoplaySpeed: 500,
      };

      var clientLogo = {
        dots: false,
    infinite: true,
        slidesToShow: 6,
        slidesToScroll: 1,
        cssEase: 'linear',
      autoplay: true,
    // speed: 500,
    // autoplaySpeed: 500,
        responsive: [
            {
              breakpoint: 1024,
              settings: {
                slidesToShow: 3,
                slidesToScroll: 3,
                infinite: true,
                dots: true
              }
            }
        ]
      };

      var Instalations = {
        dots: false,
      infinite: true,
        slidesToShow: 4,
        slidesToScroll: 1,
        cssEase: 'linear',
       autoplay: true,
    // speed: 500,
    // autoplaySpeed: 500,
        responsive: [
            {
              breakpoint: 1024,
              settings: {
                slidesToShow: 1,
                slidesToScroll:1,
                infinite: true,
                dots: true
              }
            }
        ]
      };


      
    return (
       <section>
        <Header/>
         <main>
    
      {/* <div className="w-nav-overlay" id="w-nav-overlay-0"></div> */}
      {/* ///////
      // Section-1 */}
      
      <div className="section banner-home-1">
         
             <div className="basecontainer w-container">
              <video className="image-full is--laptop" sizes="(max-width: 479px) 100vw, 98vw" autoPlay loop muted>
                  <source src={video} type='video/mp4' />
              </video>
              <div className="content-banner-home-1">
                  <h1 className="hero">Engineering Precision.
                      <br/>Delivering Excellence.</h1>
                  {/* <p className="banner-paragraph">From brewing our own beer
                      collections to providing the best eating and drinking experience.</p> */}
                  <div className="button-banner-wrap"><a href="/arkane-services" className="primary-button">Explore Our
                          Solutions </a>
                      {/* <a href="/contact-arkane" className="secondary-button">Contact us</a> */}
                      </div>
              </div>
          </div>
      </div>
       
          
      {/* //////////
      // Section-3 */}

 <div className="section without-top-spacing section-scroll-animation">
        
          <div className="base-container w-container  animate-section-trigger">
              <div className="section-title-center">
                  <h2 className="primary-text hero">
                    Welcome to Arkane
                    </h2>
                  <p>
                       <AnimatedText text="Custom-built process solutions for the Brewery, Pharma, Food, Chemical, and Healthcare industries."  animationType="fade-up" />
                  </p>

              </div>
              <div className="w-layout-grid content-home section-scroll-animation">

                 <div className="img-block ">
                      <div className="img-container px-400 ">
                          <Slider {...settings}>
                              <img src={about01} alt="Bottle of beer" className="bottle-beer"/>
                              <img src={about02} alt="Bottle of beer" className="bottle-beer"/>
                               <img src={about03} alt="Bottle of beer" className="bottle-beer"/>
                               <img src={about04} alt="Bottle of beer" className="bottle-beer"/>
                          </Slider>
                      </div>

                  </div>
                   
                    <div className="content-about-beer">
                            <h2 className="primary-text">
                            <AnimatedText text="Introduction" animationType="rotate" /></h2>
                            <p>
                                <AnimatedText text="Arkane Engineering is a process engineering company specializing in custom-built
                                stainless-steel solutions for breweries, distilleries, pharmaceuticals, food and beverage,
                                chemical plants, and healthcare."  animationType="fade-up" />
                            </p>
                            <p>
                                 <AnimatedText text="Founded in 2016, we bring deep expertise in design, fabrication, automation, and installation
                                of process systems — backed by a commitment to quality and precision.
                                Our in-house manufacturing setup in Bangalore and our skilled engineering team allow us to
                                offer end-to-end project execution, from concept to commissioning." animationType="fade-up" />

                            </p>
                            <div className="button-content-wrap" >
                                <div className="primary-button" onClick={() => setOpen(true)}>View Details</div>
                            </div>

                            <PDFModal
        isOpen={open}
        onClose={() => setOpen(false)}
        pdfUrl={pdfUrl}
      />
                        </div>
                    
                 
                  <div className="info-about-beer about-wrapper">
                        <h2 className="primary-text">
                            <AnimatedText text="What We Do" animationType="rotate" /></h2>
                               {/* <div className="inf-wrapper">
                          <div className="about">
                              <img src={icon08} alt="Bottle of beer" className="icon-responsive"/>
                          </div>
                          <h4> <AnimatedText text="Water Degassing" animationType="rotate" /></h4>
                      </div> */}
                         <div className="inf-wrapper">
                          <div className="about">
                              <img src={icon02} alt="Bottle of beer" className="icon-responsive"/>
                          </div>
                          <h4> <AnimatedText text="Process Piping" animationType="rotate" /></h4>
                      </div>
                      <div className="inf-wrapper">
                          <div className="about">
                              <img src={icon01} alt="Bottle of beer" className="icon-responsive"/>
                          </div>
                          <h4> <AnimatedText text="Process Equipment" animationType="rotate" /></h4>
                      </div>
                     <div className="inf-wrapper">
                          <div className="about">
                              <img src={icon05} alt="Bottle of beer" className="icon-responsive"/>
                          </div>
                          <h4> <AnimatedText text="Heat Exchange & Thermal Management" animationType="rotate" /></h4>
                      </div>
                      <div className="inf-wrapper">
                          <div className="about">
                              <img src={icon04} alt="Bottle of beer" className="icon-responsive"/>
                          </div>
                          <h4> <AnimatedText text="Pasteurization Systems" animationType="rotate" /></h4>
                      </div>
                     
                       <div className="inf-wrapper">
                          <div className="about">
                              <img src={icon07} alt="Bottle of beer" className="icon-responsive"/>
                          </div>
                          <h4> <AnimatedText text="Utility & Industrial Piping" animationType="rotate" /></h4>
                      </div>
                      <div className="inf-wrapper">
                          <div className="about">
                              <img src={icon06} alt="Bottle of beer" className="icon-responsive"/>
                          </div>
                          <h4> <AnimatedText text="Fermentation Process" animationType="rotate" /></h4>
                      </div>
                     <div className="inf-wrapper">
                          <div className="about">
                              <img src={icon03} alt="Bottle of beer" className="icon-responsive"/>
                          </div>
                          <h4> <AnimatedText text="CIP/SIP Systems" animationType="rotate" /></h4>
                      </div>
                  </div>
                 
              </div>
          </div>
      </div>


     
      {/* ////////////
      // Section -2 */}

 <div className="section object-container backgrounds-gray first-story-section">
          <div className="base-container w-container">

              <div className="w-layout-grid best-content-wrapper">
                  <div className="img-content">
                  
                       <div className="img-container px-600">
                          <Slider {...settings}>
                            <img src={set01} alt="Bottle of beer" className="bottle-beer" />
                              <img src={set02} alt="Bottle of beer" className="bottle-beer" />
                               <img src={set03} alt="Bottle of beer" className="bottle-beer" />
                                <img src={set04} alt="Bottle of beer" className="bottle-beer" />
                                  <img src={set05} alt="Bottle of beer" className="bottle-beer" />
                          </Slider>
                      </div>
                    
                    
                  </div>

                  <div className="best-content-wrap  animate-section-trigger">
                      <div className="best-content">
                          <div>
                              <h2 className="primary-text"><AnimatedText text="Uncompromised Quality & Reliability" nimationType="rotate" /></h2>
                              <p className="_w-69">
                                  <AnimatedText text="We engineer every vessel, system, and process to the highest standards — ensuring
                                  reliable performance, durability, and quality you can trust. From raw materials to
                                  final testing, quality control is woven into every stage of manufacturing." nimationType="fade-up" />
                              </p>
                          </div>
                          <h5>01</h5>
                      </div>
                      <div className="best-content center-block">
                          <div>
                              <h2 className="primary-text"><AnimatedText text="Tailored Engineering Solutions" nimationType="rotate" /></h2>
                              <p className="_w-69">
                                 <AnimatedText text="Every facility is unique — and so is every solution we build. Whether
                                  it’s a microbrewery or a pharma-grade cleanroom system, we offer custom-designed
                                  systems tailored precisely to your operational and compliance requirements." nimationType="fade-up"/>
                              </p>
                          </div>
                          <h5>02</h5>
                      </div>
                      <div className="best-content">
                          <div>
                              <h2 className="primary-text"><AnimatedText text="End-to-End Project Execution" nimationType="rotate" /></h2>
                              <p className="_w-69">
                                 <AnimatedText text="From concept to commissioning, our in-house team takes full ownership
                                  of the process. Through CAD design, 3D visualization, and precision fabrication, we
                                  ensure your system is delivered on spec, on time, and on budget." nimationType="fade-up"/>
                              </p>
                          </div>
                          <h5>03</h5>
                      </div>
                      <div className="best-content center-block">
                          <div>
                              <h2 className="primary-text"><AnimatedText text="Customer-Centric Collaboration" nimationType="rotate" /></h2>
                              <p className="_w-69">
                                 <AnimatedText text="We don’t just build for you — we build with you. Our responsive
                                  support, technical training, and 100% satisfaction approach ensure your team is
                                  confident, capable, and ready to run from day one." nimationType="fade-up"/></p>
                          </div>
                          <h5>04</h5>
                      </div>
                  </div>
              </div>
          </div>
      </div>

     

      <div className="section object-container ">
          <div className="base-container w-container">
              <div className="section-title-center">
                
                     <h2 className="primary-text">Our Products & Services</h2>
                       <p>
                      Our Comprehensive Range of solutions caters to a variety of industries
                  </p>
                
              </div>
                
              <div className="layout-services">
   <div className="services-items  section-scroll-animation animate-section-trigger">
                      <img src={Service01}
                          alt="Service 1" className="service-img" />
                      <span className="service-title">
                        
                           <span className="--h4"><AnimatedText text="Pharmaceutical & Life Sciences" nimationType="rotate" /></span>
                          
                        
                         
                          <p>
                              <AnimatedText text="Precision-built systems for high-purity applications in cleanroom environments" nimationType="fade-up"/>
                          </p>
                          {/* <p className="overlay">
                              <a href="/" target="blank" className="service-tag">Filter Housings & Filtration
                                  Systems&nbsp;<i className="fa-chevron-circle-right fa"></i></a>
                              <a href="/" target="blank" className="service-tag">Clean-in-Place (CIP) Systems&nbsp;<i
                                      className="fa-chevron-circle-right fa"></i></a>
                              <a href="/" target="blank" className="service-tag">Pressure Vessels&nbsp;<i
                                      className="fa-chevron-circle-right fa"></i></a>
                              <a href="/" target="blank" className="service-tag">Heat Exchangers&nbsp;<i
                                      className="fa-chevron-circle-right fa"></i></a>
                              <a href="/" target="blank" className="service-tag">Process Piping&nbsp;<i
                                      className="fa-chevron-circle-right fa"></i></a>
                              <a href="/" target="blank" className="service-tag">Instrumentation & Automation&nbsp;<i
                                      className="fa-chevron-circle-right fa"></i></a>

                          </p> */}
                      </span>
                  </div>
                  <div className="services-items  section-scroll-animation animate-section-trigger">
                      <img src={Service02}
                          alt="Service 1" className="service-img" />
                      <span className="service-title">
                         
        <span className="--h4"><AnimatedText text="Distilleries" nimationType="rotate" /></span>
                          {/*  */}
                         
                  
                          <p>
                              <AnimatedText text="Robust, high-efficiency systems for spirit production  built to scale with compliance." nimationType="fade-up"/>

                          </p>
                          {/* <p className="overlay">
                              <a href="/" target="blank" className="service-tag">Mash Kettles, Wort Kettles &
                                  Fermentors&nbsp;<i className="fa-chevron-circle-right fa"></i></a>
                              <a href="/" target="blank" className="service-tag">Hot & Cold Liquid Tanks
                                  (HLT/CLT)&nbsp;<i className="fa-chevron-circle-right fa"></i></a>
                              <a href="/" target="blank" className="service-tag">Pressure Vessels & Heat
                                  Exchangers&nbsp;<i className="fa-chevron-circle-right fa"></i></a>
                              <a href="/" target="blank" className="service-tag">Utility & Process Piping&nbsp;<i
                                      className="fa-chevron-circle-right fa"></i></a>
                              <a href="/" target="blank" className="service-tag">Full Plant Automation & Control&nbsp;<i
                                      className="fa-chevron-circle-right fa"></i></a>

                          </p> */}
                      </span>
                  </div>
                  <div className="services-items  section-scroll-animation animate-section-trigger">
                      <img src={Service03}
                          alt="Service 1" className="service-img" />
                      <span className="service-title">
                         
  <span className="--h4"><AnimatedText text="Chemical Plants" nimationType="rotate" /></span>
                          
                         
                        
                          <p>
                              <AnimatedText text="Engineered systems for precision and safety in corrosive and high-temperature
                              environments." nimationType="fade-up"/>
                          </p>
                          {/* <p className="overlay">
                              <a href="/" target="blank" className="service-tag">Storage & Mixing Tanks&nbsp;<i
                                      className="fa-chevron-circle-right fa"></i></a>
                              <a href="/" target="blank" className="service-tag">Pressure Vessels & Heat
                                  Exchangers&nbsp;<i className="fa-chevron-circle-right fa"></i></a>
                              <a href="/" target="blank" className="service-tag">Process & Utility Piping&nbsp;<i
                                      className="fa-chevron-circle-right fa"></i></a>
                              <a href="/" target="blank" className="service-tag">CIP Systems&nbsp;<i
                                      className="fa-chevron-circle-right fa"></i></a>
                              <a href="/" target="blank" className="service-tag">Automation & Monitoring
                                  Solutions&nbsp;<i className="fa-chevron-circle-right fa"></i></a>

                          </p> */}
                      </span>
                  </div>
                  <div className="services-items  section-scroll-animation animate-section-trigger">
                      <img src={Service04}
                          alt="Service 1" className="service-img" />
                      <span className="service-title">
                         
 <span className="--h4"><AnimatedText text="Cosmetic Industry" nimationType="rotate" /></span>
                          
                         
                         
                          <p>

                              <AnimatedText text="Exquisite stainless-steel process solutions/equipment to deliver unmatched refinement and consistency in personal-care production." nimationType="fade-up"/>

                          </p>
                          {/* <p className="overlay">
                              <a href="/" target="blank" className="service-tag">Sanitary Filtration Systems&nbsp;<i
                                      className="fa-chevron-circle-right fa"></i></a>
                              <a href="/" target="blank" className="service-tag">Clean-in-Place Systems&nbsp;<i
                                      className="fa-chevron-circle-right fa"></i></a>
                              <a href="/" target="blank" className="service-tag">Pressure Vessels & Heat
                                  Exchangers&nbsp;<i className="fa-chevron-circle-right fa"></i></a>
                              <a href="/" target="blank" className="service-tag">Cold & Hot Liquid Storage Tanks&nbsp;<i
                                      className="fa-chevron-circle-right fa"></i></a>
                              <a href="/" target="blank" className="service-tag">Sterile Process Piping&nbsp;<i
                                      className="fa-chevron-circle-right fa"></i></a>

                          </p> */}
                      </span>
                  </div>


                  
                  <div className="services-items  section-scroll-animation animate-section-trigger">
                      <img src={Service05}
                          alt="Service 1" className="service-img" />
                      <span className="service-title">
                         
     <span className="--h4"><AnimatedText text=" Food & Beverage Processing" nimationType="rotate" /></span>
                          
                         
                     
                          <p>

                              <AnimatedText text="Hygienic, high-performance systems for safe and efficient food & dairy operations." nimationType="fade-up"/>

                          </p>
                          {/* <p className="overlay">
                              <a href="/" target="blank" className="service-tag">CIP Systems & Filtration Units&nbsp;<i
                                      className="fa-chevron-circle-right fa"></i></a>
                              <a href="/" target="blank" className="service-tag">Process & Utility Piping&nbsp;<i
                                      className="fa-chevron-circle-right fa"></i></a>
                              <a href="/" target="blank" className="service-tag">Pressure Vessels & Heat
                                  Exchangers&nbsp;<i className="fa-chevron-circle-right fa"></i></a>
                              <a href="/" target="blank" className="service-tag">Cold & Hot Liquid Tanks&nbsp;<i
                                      className="fa-chevron-circle-right fa"></i></a>
                              <a href="/" target="blank" className="service-tag">Cleanroom-Compliant Design&nbsp;<i
                                      className="fa-chevron-circle-right fa"></i></a>

                          </p> */}
                      </span>
                  </div>
                  <div className="services-items  section-scroll-animation animate-section-trigger">
                      <img src={Service06}
                          alt="Service 1" className="service-img" />
                      <span className="service-title">
                         
                           <span className="--h4"><AnimatedText text="Breweries" nimationType="rotate" /></span>
                          
                         
                         
                          <p>
                              <AnimatedText text="Complete brewery engineering — from pilot plants to full-scale production." nimationType="fade-up"/>
                          </p>
                          {/* <p className="overlay">
                              <a href="/" target="blank" className="service-tag">Mash Kettle, Lauter Tun, Wort Kettle,
                                  Whirlpool&nbsp;<i className="fa-chevron-circle-right fa"></i></a>
                              <a href="/" target="blank" className="service-tag">Fermentors & Uni-Tanks&nbsp;<i
                                      className="fa-chevron-circle-right fa"></i></a>
                              <a href="/" target="blank" className="service-tag">Glycol & Utility Piping&nbsp;<i
                                      className="fa-chevron-circle-right fa"></i></a>
                              <a href="/" target="blank" className="service-tag">CIP Systems&nbsp;<i
                                      className="fa-chevron-circle-right fa"></i></a>
                              <a href="/" target="blank" className="service-tag">Hot & Cold Liquid Tanks&nbsp;<i
                                      className="fa-chevron-circle-right fa"></i></a>
                              <a href="/" target="blank" className="service-tag">Plate & Tube Heat Exchangers&nbsp;<i
                                      className="fa-chevron-circle-right fa"></i></a>

                          </p> */}
                      </span>
                  </div>
               
              </div>

          </div>
      </div>
  

   <div className="section backgrounds-gray object-container first-story-section">
          <div className="base-container w-container">
              <div className="section-title-center">
                  <h2 className="primary-text">Our Clients</h2>
                  <p>
                      From vision to operational readiness, we’re by your side with exceptional guidance.
                  </p>
              </div>

              <div className="section-client-logo">
                  <Slider {...clientLogo}>
                      <div className="logo-container">
                          <img src={Clients01} alt="Logo" className="_company_logo" />
                      </div>

                         <div className="logo-container">
                          <img src={Clients09} alt="Logo" className="_company_logo" />
                      </div>

                      <div className="logo-container">
                          <img src={Clients02} alt="Logo" className="_company_logo" />
                      </div>

                      <div className="logo-container">
                          <img src={Clients03} alt="Logo" className="_company_logo" />
                      </div>

                      <div className="logo-container">
                          <img src={Clients04} alt="Logo" className="_company_logo" />
                      </div>

                      <div className="logo-container">
                          <img src={Clients05} alt="Logo" className="_company_logo" />
                      </div>

                       <div className="logo-container">
                          <img src={Clients06} alt="Logo" className="_company_logo" />
                      </div>
                       <div className="logo-container">
                          <img src={Clients07} alt="Logo" className="_company_logo" />
                      </div>
                         <div className="logo-container">
                          <img src={Clients08} alt="Logo" className="_company_logo" />
                      </div>

                         <div className="logo-container">
                          <img src={Clients09} alt="Logo" className="_company_logo" />
                      </div>
                        <div className="logo-container">
                          <img src={Clients10} alt="Logo" className="_company_logo" />
                      </div>
                        <div className="logo-container">
                          <img src={Clients11} alt="Logo" className="_company_logo" />
                      </div>
                        <div className="logo-container">
                          <img src={Clients12} alt="Logo" className="_company_logo" />
                      </div>
                        <div className="logo-container">
                          <img src={Clients13} alt="Logo" className="_company_logo" />
                      </div>
                       <div className="logo-container">
                          <img src={Clients14} alt="Logo" className="_company_logo" />
                      </div>
                  </Slider>
              </div>
          </div>
      </div>

      {/* //////// Section-5 */}
      
   <div className="section object-container section-scroll-animation animate-section-trigger">
          <div className="base-container w-container">
              <div className="section-title-center">
                  <h2 className="primary-text">Our Installations</h2>
                  <p>
                     Our Latest Customer Installations 
                  </p>
              </div>

              <div className="section-Instalations">
                  <Slider {...Instalations}>
                      <div className="Instalations-container">
                          <img src={installation01} alt="Logo" className="_img--company" />
                          <div className="-overlay">
                              <span className="Instalations-name"><span className="-h4">Toit Brewery Project</span><p className="location">Nelamangala, India</p>
                                  </span>
                              {/* <p><AnimatedText text="Lorem ipsum dolor sit amet consectetur. Diam etiam convallis orci a sed duis elit
                                  venenatis." nimationType="fade-up"/></p> */}
                          </div>
                      </div>

                      <div className="Instalations-container">
                          <img src={installation02} alt="Logo" className="_img--company" />
                          <div className="-overlay">
                              <span className="Instalations-name"><span className="-h4">Toit Brewery Project</span><p className="location">Nelamangala, India</p>
                                  </span>
                              {/* <p><AnimatedText text="Lorem ipsum dolor sit amet consectetur. Diam etiam convallis orci a sed duis elit
                                  venenatis." nimationType="fade-up"/></p> */}
                          </div>
                      </div>

                      <div className="Instalations-container">
                          <img src={installation03} alt="Logo" className="_img--company" />
                          <div className="-overlay">
                              <span className="Instalations-name"><span className="-h4">Caldera Project</span><p className="location">Kolkata, India</p>
                                  </span>
                              {/* <p><AnimatedText text="Lorem ipsum dolor sit amet consectetur. Diam etiam convallis orci a sed duis elit
                                  venenatis." nimationType="fade-up"/></p> */}
                          </div>
                      </div>

                      <div className="Instalations-container">
                          <img src={installation04} alt="Logo" className="_img--company" />
                          <div className="-overlay">
                              <span className="Instalations-name"><span className="-h4">Caldera Project</span><p className="location">Kolkata, India</p>
                                  </span>
                              {/* <p><AnimatedText text="Lorem ipsum dolor sit amet consectetur. Diam etiam convallis orci a sed duis elit
                                  venenatis." nimationType="fade-up"/></p> */}
                          </div>
                      </div>

                      <div className="Instalations-container">
                          <img src={installation05} alt="Logo" className="_img--company" />
                          <div className="-overlay">
                              <span className="Instalations-name"><span className="-h4">Biozeen Project</span><p className="location">Bengaluru, India</p>
                                  </span>
                              {/* <p><AnimatedText text="Lorem ipsum dolor sit amet consectetur. Diam etiam convallis orci a sed duis elit
                                  venenatis." nimationType="fade-up"/></p> */}
                          </div>
                      </div>

                         <div className="Instalations-container">
                          <img src={installation06} alt="Logo" className="_img--company" />
                          <div className="-overlay">
                              <span className="Instalations-name"><span className="-h4">Dunkel Project</span><p className="location">Bengaluru, India</p>
                                  </span>
                              {/* <p><AnimatedText text="Lorem ipsum dolor sit amet consectetur. Diam etiam convallis orci a sed duis elit
                                  venenatis." nimationType="fade-up"/></p> */}
                          </div>
                      </div>

                         <div className="Instalations-container">
                          <img src={installation07} alt="Logo" className="_img--company" />
                          <div className="-overlay">
                              <span className="Instalations-name"><span className="-h4">Benki Project</span><p className="location">Bengaluru, India</p>
                                  </span>
                              {/* <p><AnimatedText text="Lorem ipsum dolor sit amet consectetur. Diam etiam convallis orci a sed duis elit
                                  venenatis." nimationType="fade-up"/></p> */}
                          </div>
                      </div>

                         <div className="Instalations-container">
                          <img src={installation08} alt="Logo" className="_img--company" />
                          <div className="-overlay">
                              <span className="Instalations-name"><span className="-h4">The Grid Project</span><p className="location">Kolkata, India</p>
                                  </span>
                              {/* <p><AnimatedText text="Lorem ipsum dolor sit amet consectetur. Diam etiam convallis orci a sed duis elit
                                  venenatis." nimationType="fade-up"/></p> */}
                          </div>
                      </div>

                         <div className="Instalations-container">
                          <img src={installation09} alt="Logo" className="_img--company" />
                          <div className="-overlay">
                              <span className="Instalations-name"><span className="-h4">Toit Brewery Project</span><p className="location">Pune, India</p>
                                  </span>
                              {/* <p><AnimatedText text="Lorem ipsum dolor sit amet consectetur. Diam etiam convallis orci a sed duis elit
                                  venenatis." nimationType="fade-up"/></p> */}
                          </div>
                      </div>

                         <div className="Instalations-container">
                          <img src={installation10} alt="Logo" className="_img--company" />
                          <div className="-overlay">
                              <span className="Instalations-name"><span className="-h4">Bonomi Project</span><p className="location">Bengaluru, India</p>
                                  </span>
                              {/* <p><AnimatedText text="Lorem ipsum dolor sit amet consectetur. Diam etiam convallis orci a sed duis elit
                                  venenatis." nimationType="fade-up"/></p> */}
                          </div>
                      </div>
                  </Slider>
              </div>
          </div>

      </div>
      

          {/* ///////
      // Section-5 */}

      <div className="section backgrounds-gray object-container first-story-section animate-section-trigger">
          <div className="base-container w-container">
              <div className="section-title-center ">
                 
    <h2 className="primary-text">industries we cater to</h2>
                  <p>
                      Serving diverse industries with refined stainless-steel craftsmanship and uncompromising manufacturing excellence.
                  </p>
                 
              
              </div>
              {/* /////////// Section-Services */}
              <div className="section-12 w-layout-beer">
                  <Slider {...settings}>
                      {/* //// Slider-1 */}
                       
      <div className="w-layout-beer-wrapper">

                          <div className="w-layout-grid beer-wrapper">
                              <div id="w-node-c3bc15d4-d567-20ff-2271-35506b53126c-14ad8133" className="beer-img-wrap">
                                  <img className="_3-beers" src={cater01} alt="3 Bottle of beer" />
                              </div>
                              <div id="w-node-a01ef62e-20f6-934a-f5be-5840135893af-14ad8133" className="our-beer-wrap">

                                  <div className="w-node-beer-wrapper">
                                      <h3><AnimatedText text="Brewery & Distillery
                                          From grain to glass, we engineer with passion." nimationType="scale"/>
                                      </h3>
                                      <p>
                                          <AnimatedText text="With years of experience designing and installing high-performance brewhouses,
                                          fermentors, and complete utility systems, we help craft brewers and
                                          distilleries scale faster with consistency and compliance." nimationType="fade-up"/>
                                      </p>
                                      
                                           <p className="paragraph-contact-us">High-quality stainless steel vessels</p>
                                           <p className="paragraph-contact-us">Automated CIP & utility piping</p>
                                           <p className="paragraph-contact-us">Scalable brewhouse design & installation</p>
                                      
                                    
                                  </div>
                              </div>

                          </div>
                      </div>
                       
                

                      {/* //// Slider-2 */}
                       
  <div className="w-layout-beer-wrapper">
                          <div className="w-layout-grid beer-wrapper">
                              <div id="w-node-c3bc15d4-d567-20ff-2271-35506b53126c-14ad8133" className="beer-img-wrap">
                                  <img className="_3-beers" src={cater02} alt="3 Bottle of beer" />
                              </div>
                              <div id="w-node-a01ef62e-20f6-934a-f5be-5840135893af-14ad8133" className="our-beer-wrap">
                                  <div className="w-node-beer-wrapper">
                                      <h3><AnimatedText text="Cosmetic Industry" nimationType="scale"/></h3>
                                      <p><AnimatedText text="Our expertly crafted stainless-steel equipment meets the stringent hygiene and performance requirements of modern cosmetics, enabling smooth emulsification, contamination-free storage, and efficient production of lotions, creams, and personal-care products." nimationType="fade-up"/>
                                          and compliance.</p>
                                          
                                                <p className="paragraph-contact-us">Mixing / Blending Vessels</p>
                                                <p className="paragraph-contact-us">Jacketed Heating & Cooling Vessels</p>
                                                <p className="paragraph-contact-us">Pump & Piping Skids with Tri-Clamp Fittings</p>
                                                <p className="paragraph-contact-us">High-Shear Homogenizer Vessels</p>
                                          
                                     
                                  </div>
                              </div>

                          </div>
                      </div>
                       
                    

                      {/* //// Slider-3 */}
                       
   <div className="w-layout-beer-wrapper">
                          <div className="w-layout-grid beer-wrapper">
                              <div id="w-node-c3bc15d4-d567-20ff-2271-35506b53126c-14ad8133" className="beer-img-wrap">
                                  <img className="_3-beers" src={cater03} alt="3 Bottle of beer" />
                              </div>

                              <div id="w-node-a01ef62e-20f6-934a-f5be-5840135893af-14ad8133" className="our-beer-wrap">
                                  <div className="w-node-beer-wrapper">
                                      <h3><AnimatedText text="Pharmaceutical & cosmetic industry Engineered for purity. Built for compliance." nimationType="scale"/></h3>
                                      <p><AnimatedText text="We specialize in hygienic design for cleanroom
                                          environments, offering solutions that meet the highest global standards like
                                          cGMP, ASME BPE, and FDA guidelines." nimationType="fade-up"/></p>
                                          
                                                <p className="paragraph-contact-us">CIP/SIP systems & bioreactors</p>
                                                <p className="paragraph-contact-us">Pharmaceutical-grade water systems (PW/WFI)</p>
                                                <p className="paragraph-contact-us">Full lifecycle validation & documentation</p> 
                                                 <p className="paragraph-contact-us">Pressure vessels & heat exchangers</p>
                                                <p className="paragraph-contact-us">Storage & Mixing Tanks</p>
                                  </div>
                              </div>

                          </div>
                      </div>
                       
                   
{/* //// Slider-4 */}
                    
                         <div className="w-layout-beer-wrapper">
                          <div className="w-layout-grid beer-wrapper">
                              <div id="w-node-c3bc15d4-d567-20ff-2271-35506b53126c-14ad8133" className="beer-img-wrap">
                                  <img className="_3-beers" src={cater04} alt="3 Bottle of beer" />
                              </div>
                              <div className="our-beer-wrap">
                                  <div className="w-node-beer-wrapper">
                                      <h3><AnimatedText text="Food & Beverage Processing
                                          Built to keep your processes clean, safe, and efficient." nimationType="scale"/></h3>
                                      <p><AnimatedText text="Our equipment and systems are designed to meet
                                          rigorous food safety standards, ensuring hygiene, durability, and product
                                          integrity at every stage of production." nimationType="fade-up"/></p>
                                          
                                                <p className="paragraph-contact-us">Pasteurization, filtration, and storage systems</p>
                                                <p className="paragraph-contact-us">Food-grade piping and process automation</p>
                                                <p className="paragraph-contact-us">Compliance with global hygiene norms</p>
                                          
                                    
                                  </div>
                              </div>

                          </div>
                      </div>
                    
                     

                       
  <div className="w-layout-beer-wrapper">
                          <div className="w-layout-grid beer-wrapper">
                              <div id="w-node-c3bc15d4-d567-20ff-2271-35506b53126c-14ad8133" className="beer-img-wrap">
                                  <img className="_3-beers" src={cater05} alt="3 Bottle of beer" />
                              </div>
                              <div id="w-node-a01ef62e-20f6-934a-f5be-5840135893af-14ad8133" className="our-beer-wrap">
                                  <div className="w-node-beer-wrapper">
                                      <h3><AnimatedText text="Chemical Processing
                                          Precision systems for complex and corrosive environments." nimationType="scale"/></h3>
                                      <p><AnimatedText text="From mixing and storage to transfer and
                                          recovery, we engineer systems to handle hazardous, high-pressure, and
                                          high-temperature chemical processes with full safety and control." nimationType="fade-up"/></p>
                                          
                                                    <p className="paragraph-contact-us">Pressure vessels & heat exchangers</p>
                                                    <p className="paragraph-contact-us">Process & utility piping</p>
                                                    <p className="paragraph-contact-us">Explosion-proof instrumentation & controls</p>
                                          
                                      

                                  </div>
                              </div>

                          </div>
                      </div>
                       
                  </Slider>
              </div>

          </div>
      </div>
   
      
  <div className="section object-container section-scroll-animation animate-section-trigger">
          <div className="base-container w-container">
              <div className="section-title-center">
                  <h2 className="primary-text">The Team</h2>
                  <p>
                     <AnimatedText text="Powered by skilled engineers and specialists united in delivering superior quality and long-term reliability." nimationType="fade-up"/>
                  </p>
              </div>

              <div className="w-layout-grid best-content-wrapper best-content-wrapper-border-curve">
                  <div className="best-content-wrap">
                      <div className="best-content flex-grid-list-wrap">
                            <h2 className="primary-text"><AnimatedText text="From Our Managing Director" nimationType="scale"/></h2>
                                <span className="-grid-list-wrap">
                                    <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="currentColor" className="bi bi-diamond-fill" viewBox="0 0 16 16">
                                    <path fill-rule="evenodd" d="M6.95.435c.58-.58 1.52-.58 2.1 0l6.515 6.516c.58.58.58 1.519 0 2.098L9.05 15.565c-.58.58-1.519.58-2.098 0L.435 9.05a1.48 1.48 0 0 1 0-2.098z"/>
                                    </svg>
                                    <p className="_w-69"><AnimatedText text="At Arkane Engineering, we don’t just deliver process systems — we deliver trust, quality, and long-term partnerships." nimationType="fade-up"/></p>
                                </span>
                                <span className="-grid-list-wrap">
                                    <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="currentColor" className="bi bi-diamond-fill" viewBox="0 0 16 16">
                                    <path fill-rule="evenodd" d="M6.95.435c.58-.58 1.52-.58 2.1 0l6.515 6.516c.58.58.58 1.519 0 2.098L9.05 15.565c-.58.58-1.519.58-2.098 0L.435 9.05a1.48 1.48 0 0 1 0-2.098z"/>
                                    </svg>
                                    <p className="_w-69"><AnimatedText text="Avenash Kumar, a seasoned mechanical engineer with deep expertise in the brewery, pharmaceutical, and process engineering sectors, leads the company with a hands-on approach. From conceptual design to final delivery, his involvement ensures every project reflects Arkane’s core values — precision, commitment, and customer-first thinking." nimationType="fade-up"/></p>
                                </span>
                                <span className="-grid-list-wrap">
                                    <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="currentColor" className="bi bi-diamond-fill" viewBox="0 0 16 16">
                                    <path fill-rule="evenodd" d="M6.95.435c.58-.58 1.52-.58 2.1 0l6.515 6.516c.58.58.58 1.519 0 2.098L9.05 15.565c-.58.58-1.519.58-2.098 0L.435 9.05a1.48 1.48 0 0 1 0-2.098z"/>
                                    </svg>
                                    <p className="_w-69"><AnimatedText text="Under his leadership, Arkane has grown into a dependable partner for process industries across India, with a vision to scale globally through innovation and excellence." nimationType="fade-up"/></p>
                                </span>
                      </div>
                  </div>
                  <div className="img-content">
                      <img src={director} alt="Bottle of beer" className="team-image" />
                  </div>

              </div>

          </div>
      </div>
      

            <div className="section backgrounds-gray object-container first-story-section animate-section-trigger">
                <div className="base-container w-container">
                     
              <div className="w-layout-grid best-content-wrapper padding-50 section-scroll-animation">

                  <div className="img-content">
                     <img src={coreteam} alt="Bottle of beer" className="team-image" />
                  </div>
                  <div className="best-content-wrap">
                      <div className="best-content flex-grid-list-wrap">
                              <h2 className="primary-text"><AnimatedText text="Our Team" nimationType="scale"/></h2>
                                 <span className="-grid-list-wrap">
                                    <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="currentColor" className="bi bi-diamond-fill" viewBox="0 0 16 16">
                                    <path fill-rule="evenodd" d="M6.95.435c.58-.58 1.52-.58 2.1 0l6.515 6.516c.58.58.58 1.519 0 2.098L9.05 15.565c-.58.58-1.519.58-2.098 0L.435 9.05a1.48 1.48 0 0 1 0-2.098z"/>
                                    </svg>
                                    <p className="_w-69"><AnimatedText text="Behind every Arkane solution is a dedicated team of engineers, designers, and fabrication experts who bring innovation and attention to detail into every project." nimationType="fade-up"/></p>
                                 </span>
                                 <span className="-grid-list-wrap">
                                    <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="currentColor" className="bi bi-diamond-fill" viewBox="0 0 16 16">
                                    <path fill-rule="evenodd" d="M6.95.435c.58-.58 1.52-.58 2.1 0l6.515 6.516c.58.58.58 1.519 0 2.098L9.05 15.565c-.58.58-1.519.58-2.098 0L.435 9.05a1.48 1.48 0 0 1 0-2.098z"/>
                                    </svg>
                                    <p className="_w-69">
                                      <AnimatedText text="Skilled in Sheet Metal Fabrication & Control Panel Design" nimationType="fade-up"/>
                                    </p>
                                </span>
                                <span className="-grid-list-wrap">
                                    <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="currentColor" className="bi bi-diamond-fill" viewBox="0 0 16 16">
                                    <path fill-rule="evenodd" d="M6.95.435c.58-.58 1.52-.58 2.1 0l6.515 6.516c.58.58.58 1.519 0 2.098L9.05 15.565c-.58.58-1.519.58-2.098 0L.435 9.05a1.48 1.48 0 0 1 0-2.098z"/>
                                    </svg>
                                    <p className="_w-69"><AnimatedText text="Trained in Latest Industry Standards & Customer Requirements" nimationType="fade-up"/></p>
                                 </span>   
                                <span className="-grid-list-wrap">
                                    <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="currentColor" className="bi bi-diamond-fill" viewBox="0 0 16 16">
                                    <path fill-rule="evenodd" d="M6.95.435c.58-.58 1.52-.58 2.1 0l6.515 6.516c.58.58.58 1.519 0 2.098L9.05 15.565c-.58.58-1.519.58-2.098 0L.435 9.05a1.48 1.48 0 0 1 0-2.098z"/>
                                    </svg>
                                    <p className="_w-69"><AnimatedText text="Focused on Quality Control at Every Step" nimationType="fade-up"/></p>
                                </span>
                                <span className="-grid-list-wrap">
                                    <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="currentColor" className="bi bi-diamond-fill" viewBox="0 0 16 16">
                                    <path fill-rule="evenodd" d="M6.95.435c.58-.58 1.52-.58 2.1 0l6.515 6.516c.58.58.58 1.519 0 2.098L9.05 15.565c-.58.58-1.519.58-2.098 0L.435 9.05a1.48 1.48 0 0 1 0-2.098z"/>
                                    </svg>
                                    <p className="_w-69"><AnimatedText text="Committed to Continuous Learning & Engineering Excellence" nimationType="fade-up"/>
                                </p>
                                </span>
                                <span className="-grid-list-wrap">
                                    <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="currentColor" className="bi bi-diamond-fill" viewBox="0 0 16 16">
                                    <path fill-rule="evenodd" d="M6.95.435c.58-.58 1.52-.58 2.1 0l6.515 6.516c.58.58.58 1.519 0 2.098L9.05 15.565c-.58.58-1.519.58-2.098 0L.435 9.05a1.48 1.48 0 0 1 0-2.098z"/>
                                    </svg>
                                    <p className="_w-69"><AnimatedText text="Each team member is carefully selected for their technical capability, market understanding, and industry experience. Whether it’s stainless-steel fabrication, automation, or validation support — our people are our strength." nimationType="fade-up"/></p>
                               </span>
                      </div>
                  </div>

              </div>
                </div>
            </div>
      
    
      <ContactForm />
  </main>

  <Footer/>
       </section>
    )}

    export default Home;    